import type { UserSummaryDto } from '../dto';
import type { UserSummary } from '../models';

export function mapUserSummaryFromDto(dto: UserSummaryDto): UserSummary {
  return {
    id: dto.id,
    name: dto.name,
  };
}
